const headers = {
  name: "Purchase return",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "select",
      name: "sort",
      placeholder: "Sort",
      value: null,
      options: [
        { value: "1", label: "Name (A-Z)" },
        { value: "2", label: "Name (Z-A)" },
        { value: "3", label: "Price (Low)" },
        { value: "4", label: "Price (High)" },
        { value: "5", label: "Balance (Low)" },
        { value: "6", label: "Balance (High)" },
      ],
    },
    {
      type: "filter",
      name: "supplier",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Supplier",
      api: "get-all-suppliers",
      value: null,
      options: null,
    },
    {
      type: "filter",
      name: "payment",
      placeholder: "Payment",
      value: null,
      options: [
        { value: 0, label: "Paid" },
        { value: 1, label: "Partial" },
        { value: 2, label: "Unpaid" },
      ],
    },
    {
      type: "filter",
      name: "status",
      placeholder: "Status",
      value: null,
      options: [
        { value: 0, label: "Inactive" },
        { value: 1, label: "Active" },
      ],
    },
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "range",
      name: "due_date",
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "add",
      path: "/app/purchases/returns/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "LPO",
        path: "/app/purchases",
      },
      {
        name: "GRN",
        path: "/app/purchases/grn",
      },
      {
        name: "Voucher",
        path: "/app/purchases/voucher",
      },
      {
        name: "Returns",
        path: "",
      },
      {
        name: "Debit Notes",
        path: "/app/purchases/debit-notes",
      },  
    ],
    total: [
      { value: "0", label: "Total" },
      { value: "0", label: "Active" },
      { value: "0", label: "Inactive" },
      { value: "0", label: "Paid" },
      { value: "0", label: "Partial" },
      { value: "0", label: "Unpaid" },
    ],
  },
};

export default headers;
